<template>
  <main class="content">
    <van-list
      v-model="loading"
      :finished="finish"
      @load="loadMoreNews">
      <HomeNews
        :list="list"
        :more="false"/>
    </van-list>
  </main>
</template>

<script>
import HomeNews from './components/HomeNews.vue';
import HTTP from '../../libs/HTTP';

export default {
  name: 'News',
  components: {
    HomeNews,
  },
  data() {
    return {
      list: [],
      loading: false,
      finish: false,
      page: 0, // 文章页数
    };
  },
  methods: {
    async loadNews() {
      const list = [];
      const http = new HTTP('');
      // 获取文章列表
      const newsList = await http
        .get('https://blog.yikangbao.com.cn/wp-json/wp/v2/posts', { categories: 2, per_page: 5, offset: this.page });
      if (!newsList.length) {
        this.finish = true;
        return [];
      }
      this.pageIncrease();
      newsList.forEach(async (element) => {
        const news = {};
        news.id = element.id;
        news.title = element.title.rendered;
        news.url = element.link;
        news.view = element.post_view_count;
        /* eslint-disable no-underscore-dangle */
        news.imgHref = element._links['wp:featuredmedia'][0].href;
        list.push(news);
      });
      // 获取文章对应的图片
      list.forEach(async (element, index) => {
        const img = await http.get(element.imgHref);
        this.$set(list[index], 'img', img.guid.rendered);
      });
      // this.pageIncrease(!this.finish);
      return list;
    },
    async loadMoreNews() {
      const list = await this.loadNews();
      this.list.push(...list);
      this.loading = false;
    },
    pageIncrease(status = true) {
      if (status) {
        this.page = this.page + 5;
      }
    },
  },
};
</script>

<style scoped>
.content {
  /* position: absolute; */
  background-color: #fff;
}
</style>
